import { BASE } from '@/types/utils/sizesType';

import PropTypes from 'prop-types';

import { FACEBOOK, INSTAGRAM, LINKEDIN, THREADS, TIKTOK_BUSINESS, X } from '@/lib/socialProfile';

import { iconSize, iconThreads, iconTiktok, iconX } from '@/components/base/Avatar/avatarConfig';
import Icon from '@/components/base/Icon';
import Select from '@/components/base/Select';
import SpOrSpGroupAvatar from '@/components/composite/SpGroups/SpOrSpGroupAvatar';
import Instagram from '@/components/icons/Instagram';

const SelectWithSPIcon = ({
    error,
    disabled,
    selected,
    socialNetworkType,
    value,
    noValue = false,
    withDisplayName = false,
    profileData = {},
    baseStyle = 'noBorder',
    avatarSize = 'sm',
    sizeStyle = 'default',
    className
}) => {
    const renderIconSP = () => {
        if (Object.keys(profileData ?? {}).length === 0) {
            switch (socialNetworkType) {
                case INSTAGRAM:
                    return <Instagram />;
                case FACEBOOK:
                    return (
                        <Icon
                            icon="facebook"
                            className={`${iconSize[BASE]} text-facebook dark:text-white`}
                            aria-label="facebook-icon"
                        />
                    );

                case X:
                    return (
                        <Icon
                            icon="x"
                            className={`${iconX[BASE]} text-twitter dark:text-white`}
                            aria-label="x-icon"
                        />
                    );
                case LINKEDIN:
                    return (
                        <Icon
                            icon="linkedin"
                            className={`${iconSize[BASE]} text-linkedin dark:text-white`}
                            aria-label="linkedin-icon"
                        />
                    );
                case TIKTOK_BUSINESS:
                    return (
                        <Icon
                            icon="tiktok"
                            className={`${iconTiktok[BASE]} text-black dark:text-white`}
                            aria-label="tiktok-icon"
                        />
                    );
                case THREADS:
                    return (
                        <Icon
                            icon="threads"
                            className={`${iconThreads[BASE]} text-threads dark:text-white`}
                            aria-label="threads-icon"
                        />
                    );
                default:
                    return null;
            }
        } else {
            return (
                <SpOrSpGroupAvatar
                    item={profileData}
                    profileNetworkType={true}
                    profileGroupType={true}
                    size={avatarSize}
                />
            );
        }
    };

    return (
        <Select.Button
            selected={selected}
            sizeStyle={sizeStyle}
            disabled={disabled}
            baseStyle={baseStyle ?? 'noBorder'}
            error={error}
            className={className}>
            <div className="flex items-center space-x-3" data-testid="select-with-sp-icon-button">
                {selected?.value === 'all' ? (
                    <Icon className="text-base text-icoBlue" icon="single-profile" />
                ) : (
                    renderIconSP()
                )}
                {!noValue ? (
                    <div className="flex flex-col space-y-0.5 overflow-hidden">
                        <span className="block flex-1 truncate text-icoBlack dark:text-white">
                            {value ? value : selected?.label ?? selected?.value}
                        </span>
                        {withDisplayName && selected?.displayName ? (
                            <span className="block flex-1 truncate text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                                {selected?.displayName}
                            </span>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </Select.Button>
    );
};
SelectWithSPIcon.propTypes = {
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    disabled: PropTypes.bool,
    selected: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    socialNetworkType: PropTypes.string,
    value: PropTypes.string,
    profileData: PropTypes.object,
    baseStyle: PropTypes.string,
    avatarSize: PropTypes.string,
    withDisplayName: PropTypes.bool,
    className: PropTypes.string
};

export default SelectWithSPIcon;
